import { Component } from '@angular/core';

@Component({
  selector: 'app-waiting',
  standalone: true,
  imports: [],
  templateUrl: './waiting.component.html',
  styleUrl: './waiting.component.css'
})
export class WaitingComponent {

}
